var exports = {
  "Qs": "UserVideoTab.module__content___TGN3a1",
  "zN": "UserVideoTab.module__controlGroup___TGN3a1",
  "ZT": "UserVideoTab.module__deviceNotice___TGN3a1",
  "ei": "UserVideoTab.module__deviceNoticeText___TGN3a1",
  "dv": "UserVideoTab.module__deviceNoticeTitle___TGN3a1",
  "H6": "UserVideoTab.module__deviceNoticeDescription___TGN3a1",
  "IR": "UserVideoTab.module__premiumCard___TGN3a1",
  "LS": "UserVideoTab.module__premiumHeader___TGN3a1",
  "PC": "UserVideoTab.module__premiumIcon___TGN3a1",
  "CA": "UserVideoTab.module__premiumTitle___TGN3a1",
  "SM": "UserVideoTab.module__premiumDescription___TGN3a1",
  "eQ": "UserVideoTab.module__frameRateNote___TGN3a1",
  "xe": "UserVideoTab.module__frameRateIcon___TGN3a1",
  "hP": "UserVideoTab.module__actionButton___TGN3a1",
  "a9": "UserVideoTab.module__cameraControlGroup___TGN3a1",
  "$l": "UserVideoTab.module__actionRow___TGN3a1",
  "ZJ": "UserVideoTab.module__actionLabel___TGN3a1",
};

module.exports = exports;
